import { HttpCodes, IAPIResponse } from '@slottracker/utils';

import { config } from '../config';

import * as auth from './auth';

let tokenRefreshPromise: Promise<void> | null = null;
const refreshToken = async (): Promise<void> => {
    if (!tokenRefreshPromise) {
        tokenRefreshPromise = auth.refreshToken()
            .then(() => {
                tokenRefreshPromise = null;
            });
    }

    return tokenRefreshPromise;
};
const request = async <T>(url: string, options: RequestInit = {}): Promise<IAPIResponse<T>> => {
    if (!options.headers) {
        options.headers = { };
    }

    const authToken = auth.getAccessToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };

    options.headers = {
        ...options.headers,
        ...headers,
    };

    const res = await fetch(url, options);
    const resJson = await res.json() as IAPIResponse<T>;

    if (!res.ok && res.status === HttpCodes.Unauthorized && !url.includes('/auth/')) {
        try {
            await refreshToken();
        } catch (err: unknown) {
            return resJson;
        }

        return request(url, options);
    }

    return resJson;
};
const buildUrl = (endpoint: string): string => `${config.apiUrl}${endpoint}`;

export const get = async <T = unknown>(endpoint: string): Promise<IAPIResponse<T>> => {
    const url = buildUrl(endpoint);

    return request(url);
};

export const getMapped = async <T>(endpoint: string): Promise<T> => {
    const res = await get<T>(endpoint);

    return res.data;
};

export const post = async <T = unknown>(endpoint: string, body?: unknown): Promise<IAPIResponse<T>> => {
    const url = buildUrl(endpoint);

    return request(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
};

export const postMapped = async <T>(endpoint: string, body?: unknown): Promise<T> => {
    const res = await post<T>(endpoint, body);

    return res.data;
};
